import { Button, Text } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { Money } from '..'
import {
  useIsCheckoutLoadingOrUpdating,
  useDonation,
  useExperimentPaymentScheduleList,
  useShowSummaryChangeButton,
  usePaymentPlanChangeHandler,
} from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import { DueDateText } from '../PaymentSchedule/DueDateText'
import styles from './style.module.css'
import { useTranslation } from 'next-i18next'

interface Props {
  show: boolean
}

export const PaymentScheduleExperimentContent: FunctionComponent<Props> = ({ show }) => {
  const isShippingOptionUpdating = useIsCheckoutLoadingOrUpdating()
  const { isUpdatingDonation } = useDonation()
  const { textSize } = useCheckoutSizes()
  const paymentScheduleList = useExperimentPaymentScheduleList()
  const showChangePaymentScheduleButton = useShowSummaryChangeButton()
  const onChangeClick = usePaymentPlanChangeHandler()
  const { t } = useTranslation()

  if (!show) {
    return null
  }

  return (
    <div className={styles.contentWrapper}>
      {paymentScheduleList.map((schedule, index) => {
        const isLoading = isShippingOptionUpdating || (index === 0 && isUpdatingDonation)
        const showWeekday = index !== 0
        return (
          <div key={index} className={styles.textWrapper}>
            <Text color='Gray40' size={textSize}>
              <DueDateText
                verboseDueToday
                key={index}
                index={index}
                dueDate={schedule?.installmentDueDate}
                {...(showWeekday && { dateTimeFormatOptions: { weekday: 'short' } })}
              />
            </Text>
            <Text>
              <Money color='Gray40' size={textSize} value={schedule?.amount} loading={isLoading} />
            </Text>
          </div>
        )
      })}
      {showChangePaymentScheduleButton && (
        <div className={styles.changeButtonWrapper}>
          <Button.Ghost onClick={onChangeClick} size='Regular' padding='Fluid' data-testid='change-payment-plan-button'>
            {t('consumerLending:summary:changePaymentPlan')}
          </Button.Ghost>
        </div>
      )}
    </div>
  )
}
